import React from 'react';
import { Button } from 'antd';

import LocationForm from './LocationForm';
import TextForm from './TextForm';
import ListForm from './ListForm';

function getComponent (type) {
  switch (type) {
    case 'location':
      return LocationForm;
    case 'text':
      return TextForm;
    case 'list':
      return ListForm;
    default:
      return null;
  }
}

export class AddTextForm extends React.Component {
  state = {
    control: {},
    isValid: !this.props.initInvalid,
  }

  componentDidMount () {
    this.setFormData();
  }

  onChange = control =>
    this.setState(state => ({
      ...state,
      control: {
        ...state.control,
        ...control,
      },
    }))

  onValid = isValid => this.setState({ isValid });

  setFormData () {
    const { control } = this.props;
    this.setState({ control });
  }

  save = () => {
    const { onSave } = this.props;
    const { control } = this.state;
    onSave(control);
  }

  render () {
    const { saveLabel = 'Enregistrer', controls } = this.props;
    const { control, control: { type }, isValid } = this.state;
    const { onChange, onValid, save } = this;
    const Component = getComponent(type);

    if (!Component) return null;

    return (
      <React.Fragment>
        <Component
          control={control}
          controls={controls}
          onValid={onValid}
          onChange={onChange}
        />
        <Button
          disabled={!isValid}
          onClick={save}
        >
          {saveLabel}
        </Button>
      </React.Fragment>
    );
  }
}

export default AddTextForm;



// WEBPACK FOOTER //
// ./src/components/Admin/ActivitiesManagement/ActivityEdit/Control/Form.js